import { IGeoAddressDetailsSchema } from '../../types';

export const getFBGeo = (details: IGeoAddressDetailsSchema[]) => {
  return details.filter(item => item.type === 'location').map(item => item.fullName);
};
